// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ImgCoreTs from "./ImgCore.ts";

var getSrcSet2 = ImgCoreTs.getSrcSet2;

export {
  getSrcSet2 ,
  
}
/* getSrcSet2 Not a pure module */
